export default __webpack_public_path__ + "static/media/network-bg.91a2f93f.svg";